import { render } from "./Stats.vue?vue&type=template&id=5126fd72&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=5126fd72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5126fd72"]])

export default __exports__